/**
 * @fileoverview POST handler for the "/internal_user_groups/extract_users_from_ids" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsExtractUsersFromIdsCacheKeys } from "./constants";
import type {
  PostAppSettingsInternalUserGroupsExtractUsersFromIdsProps,
  AppSettingsInternalUserGroupsExtractUsersFromIdsResult,
} from "./types";

export const postAppSettingsInternalUserGroupsExtractUsersFromIds = reactQueryMutationAdapter(
  appSettingsInternalUserGroupsExtractUsersFromIdsCacheKeys,
  ({
    idsString,
    internalUserGroupId,
  }: PostAppSettingsInternalUserGroupsExtractUsersFromIdsProps): Promise<AppSettingsInternalUserGroupsExtractUsersFromIdsResult> => {
    const params = { ids_string: idsString, internal_user_group_id: internalUserGroupId };

    return fetch("/internal_user_groups/extract_users_from_ids", "POST", params, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
